export default __webpack_public_path__ + "static/media/interno_1.ce9243f1.jpg";